// assets - iconos outline (estilo menú verde oscuro)
import {
    IconUsers,
    IconBallFootball,
    IconClipboardList,
    IconChartBar
} from '@tabler/icons';

// constant
const icons = {
    IconUsers,
    IconBallFootball,
    IconClipboardList,
    IconChartBar
};

//-----------------------|| MENU ITEMS - Estilo lista plana con iconos outline ||-----------------------//

export const other = {
    id: 'main-nav',
    type: 'group',
    title: '', // sin título para lista plana como en la referencia
    children: [
        {
            id: 'students-page',
            title: 'Students',
            type: 'item',
            url: '/students',
            icon: icons.IconUsers,
            breadcrumbs: false
        },
        {
            id: 'trainers-page',
            title: 'Trainers',
            type: 'item',
            url: '/trainer',
            icon: icons.IconBallFootball,
            breadcrumbs: false
        },
        {
            id: 'training-page',
            title: 'Exercises',
            type: 'item',
            url: '/training',
            icon: icons.IconClipboardList,
            breadcrumbs: false
        },
        {
            id: 'reports-page',
            title: 'Reports',
            type: 'item',
            url: '/reports',
            icon: icons.IconChartBar,
            breadcrumbs: false
        }
    ]
};
